import { render, staticRenderFns } from "./healthAndSafetyCommittee.vue?vue&type=template&id=60b870ee"
import script from "./healthAndSafetyCommittee.vue?vue&type=script&lang=js"
export * from "./healthAndSafetyCommittee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports